import Menu from './Menu.vue';
import MenuItem from './MenuItem.vue';
import SubMenu from './SubMenu.vue';

Menu.Item = MenuItem;
Menu.SubMenu = SubMenu;

Menu.install = function(app) {
  app.component(Menu.name, Menu);
  app.component(MenuItem.name, MenuItem);
  app.component(SubMenu.name, SubMenu);
};

export default Menu; 